
<template>
  <v-layout row justify-center>
    <v-card min-width="350px" class="mt-16 rounded-xl" :loading="loading">
      <v-card-title class="d-flex justify-center">
        <span class="headline"> Регистрация </span>
      </v-card-title>
      <v-card-text class="">
        <v-container grid-list-md>
          <v-layout>
            <v-flex>
              <v-form class="mt-2">
                <v-text-field
                  label="E-mail"
                  v-model="email"
                  :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                  autocomplete
                  autofocus
                  required
                  class=""
                ></v-text-field>
                <v-text-field
                  label="Пароль"
                  v-model="password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-count="2"
                  :error-messages="passwordErrors"
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                  @click:append="show = !show"
                  required
                  counter
                  autocomplete
                  :type="show ? 'text' : 'password'"
                  class=""
                ></v-text-field>
                <v-row class="d-flex justify-start flex-wrap pt-2 pb-5">
                  <v-checkbox
                    label=""
                    v-model="checkbox"
                    :error-messages="checkboxErrors"
                    @change="$v.checkbox.$touch()"
                    @blur="$v.checkbox.$touch()"
                    required
                    class="pl-2"
                  ></v-checkbox>
                  <span class="pt-5"
                    >Согласен с
                    <router-link to="/agreement" class="link">
                      пользовательским соглашением
                    </router-link>
                  </span>
                </v-row>

                <v-btn
                  color="light-blue lighten-4"
                  block
                  class="text-none subtitle-1"
                  :disabled="this.$v.$invalid || !this.checkbox"
                  :loading="loading"
                  :disable="loading"
                  @click="submit"
                >
                  Продолжить
                </v-btn>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-layout>
</template>


<script>
// import apiInstance from "../config/api";
import auth from "../config/auth";
import { required, email, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  mixins: [validationMixin],

  validations: {
    email: {
      // async isUnique(value) {
      //   // console.log("value: " + value);
      //   // if (value === "") return true;
      //   const response = await axios.post(this.url, { email: value });
      //   return Boolean(await response.result);
      // },
      required,
      email,
      isUnique(value) {
        if (value === "") return true;
        this.checkingUsername = true;

        return auth
          .post(this.check_url, { email: this.email })
          .then((response) => {
            // console.log(response);
            this.checkingUsername = false;
            return response.data.result;
          })
          .catch(() => {
            return false;
          });
      },
    },
    password: {
      minLength: minLength(8),
      required,
      containsUppercase: function (value) {
        return /[A-Z]/.test(value);
      },
      containsLowercase: function (value) {
        return /[a-z]/.test(value);
      },
      containsNumber: function (value) {
        return /[0-9]/.test(value);
      },
    },
    checkbox: { required },
  },

  data: () => ({
    email: "",
    password: "",
    check_url: "/auth/check_email_unique/",
    url: "/auth/users/",
    checkbox: false,
    submitStatus: "",
    show: false,
    loader: null,
    loading: false,
  }),

  computed: {
    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      !this.$v.checkbox.required &&
        errors.push("Вы должны принять условия соглашения, чтобы продолжить");
      // console.log("checkbox errors: " + errors);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      const email_regex = !this.$v.email.email;
      const email_required = !this.$v.email.required;
      email_regex && errors.push("Введёный адрес не является e-mail");
      email_required && errors.push("E-mail - обязательное поле");
      if (!email_regex && !email_required) {
        !this.$v.email.isUnique && errors.push("E-mail не доступен");
      }
      // console.log("errors: " + errors);
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("Пароль должен быть не меньше 8 символов");
      !this.$v.password.required && errors.push("Пароль - обязательное поле");
      !this.$v.password.containsLowercase &&
        errors.push("Пароль должен содержать хотя бы одну маленькую букву");
      !this.$v.password.containsUppercase &&
        errors.push("Пароль должен содержать хотя бы одну заглавную букву");
      !this.$v.password.containsNumber &&
        errors.push("Пароль должен содержать хотя бы одну цифру");
      console.error(errors);
      return errors;
    },
  },

  methods: {
    submit: function () {
      this.$v.$touch();

      this.loading = true;
      // console.log("email:" + this.email);
      auth
        .post(this.url, { email: this.email, password: this.password })
        .then((response) => {
          console.info(response.data);
          this.loading = false;
          this.$router.push({ name: "after_register" });
        })
        .catch((error) => {
          console.error(error.data);
          this.loading = false;
        });
    },
    checkEmail() {
      auth.post(this.check_url, { email: this.email }).then((response) => {
        return response;
      });
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var token = localStorage.getItem("token");
      if (token) {
        vm.$router.push({ name: "home" });
      }
    });
  },
};
</script>